import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { WarehouseTransferDataGrid } from "src/components/views/erp/warehouse/transfer/WarehouseTransferDataGrid.tsx";
import { useKeptAliveView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/warehouse/warehouseTransfers")({
	staticData: { title: i18n.t("warehouse_transfers"), legacyViewKey: "warehouseTransferView" },
	component: RouteComponent,
});

function RouteComponent() {
	const { isActive } = useKeptAliveView();
	return <WarehouseTransferDataGrid isActive={isActive} />;
}
